/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Inject, Injectable} from '@angular/core';
import * as _ from 'lodash';

import {WorkspaceResource} from './api/resources/resource/workspace.resource';
import {LocalUserProfile} from './session/local-user-profile';

@Injectable({
  providedIn: 'root'
})
export class WorkspaceRegistryService {
  workspaces: any[] = [];
  $promise: any;

  constructor(
    // Factory product — duck-typed resource API (query/get/save/...).
    @Inject(WorkspaceResource) private readonly Workspace: any,
    private readonly localUserProfile: LocalUserProfile
  ) {
  }

  sync(): any {
    if (this.localUserProfile.getCurrentApp() !== 'ADVERTISING') {
      return Promise.resolve();
    }
    this.$promise = this.Workspace.query().$promise.then((page: any) => {
      const sorted = _.sortBy(page.results, sortByName);
      this.workspaces.length = 0;
      _.forEach(sorted, (ws) => {
        this.workspaces.push(ws);
      });
      return this.workspaces;
    });
    return this.$promise;
  }

  getPromise(): any {
    return this.$promise || this.sync();
  }

  remove(workspace: any): any {
    return _.remove(this.workspaces, ['id', workspace.id]);
  }

  update(workspace: any): void {
    this.remove(workspace);
    this.workspaces.unshift(workspace);
    const sortedWorkspaces = _.sortBy(this.workspaces, sortByName);
    this.workspaces.length = 0;
    _.forEach(sortedWorkspaces, (ws) => {
      this.workspaces.push(ws);
    });
  }
}

function sortByName(ws: any): string {
  return (ws.name || '').toLowerCase();
}
